import { gql } from '@apollo/client';

export const CommandeLine = {
  fragments: {
    mainCommandeLine: gql`
      fragment MainCommandeline on Commandeline {
        quantite
        produit {
          data {
            id
            attributes {
              name
              ttcPrice
              ref
              venterebond
              media {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `
  }
};
